import { render, staticRenderFns } from "./InfoRestaurante.vue?vue&type=template&id=4116b091&scoped=true"
import script from "./InfoRestaurante.vue?vue&type=script&lang=js"
export * from "./InfoRestaurante.vue?vue&type=script&lang=js"
import style0 from "./InfoRestaurante.vue?vue&type=style&index=0&id=4116b091&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4116b091",
  null
  
)

export default component.exports